import axios from 'axios';
import authHeader from "./auth-header";
import {config} from "../constants";

class SanctionService {

    actives() {
        return axios.get(config.API_URL + "sanction-list/active", {headers: authHeader()})
    }

    removeSanctionList() {
        localStorage.removeItem("sanctionList")
    }

    saveSanctionList(sanctionList) {
        localStorage.setItem("sanctionList", JSON.stringify(sanctionList))
    }

    getCurrentSanctionList() {
        // return JSON.parse(localStorage.getItem('sanctionList'));
        return null
    }

}

export default new SanctionService();
